import React, { useEffect, useMemo, useState, useRef } from 'react';
import MaterialTable, {MTableActions, MTableBody, MTableHeader, MTableToolbar} from 'material-table';
import { History } from '@material-ui/icons';

import {
  renderNameTooltip,
  renderEditMoneyComponent,
  renderNamesString,
  renderNullFloatValues,
  renderCompleteValue,
  getFieldRenderFunction,
  filterKpisByYear
} from './Shared';
import Form from 'react-bootstrap/Form';
import {localization, modifyDefaultOptions, options} from '../../helpers/table';
import {getStickyColumns, FilterInput} from '../../helpers/table.jsx';
import { range, tableIcons } from '../../helpers';
import { getAllResults } from '../../services/factsSvc';
import { dateRenderer } from '../../services/formatSvc';
import { isAdmin, isAdminRead } from '../../services/rolesSvc';

import useUserContext from '../../hooks/useUserContext';

import DownloadLink from '../../components/common/DownloadLink';
import MTableFilterRow from '../../components/material-table-overrides/MTableFilterRow';
import KpiHistoryModal from './KpiHistoryModal';
import CustomTableActions from "../../components/table/CustomTableActions";
import LoadingTable from '../../components/table/LoadingTable';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import settingsIcon from '../../../img/icons/icon-settings.svg';
import HideColumnButton from '../../components/UI/HideColumnButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import CalcDescriptionModal from '../../components/Indexes/CalcDescriptionModal';

// TODO: remove hardcode
const DEFAULT_YEAR = 2025;
const years = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];
const months = ['02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
const currentMonth="0"+ ( new Date().getMonth() + 1);

const passByYear = (val, years) => {
  if(years.length === 0) return true;
  const startDate = new Date(val.startDate);
  const endDate = new Date(val.endDate);
  const nowDate = new Date();
  startDate.setHours(0,0,0,0)
  endDate.setHours(0,0,0,0)
  nowDate.setHours(0,0,0,0)
  return years.length === 1 && years[0] === nowDate.getFullYear()
    ? (!val.startDate || startDate.getTime() <= nowDate.getTime()) &&
    (!val.endDate || endDate.getTime() >= nowDate.getTime())
    : (!val.startDate || years.some(year => startDate.getFullYear() <= year)) &&
      (!val.endDate || years.some(year => endDate.getFullYear() >= year));
}

const recursiveHasParent = (val, array) => {
  if(!val.parentId) return true;
  const currentParent = array.find(parent => parent.path === val.parentId);
  if(currentParent) return recursiveHasParent(currentParent, array);
  return false;
}

export default function PartFactResult() {
  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);
  const [filterYears, setFilterYears] = useState([DEFAULT_YEAR]);
  const [columns, setColumns] = useState([]);
  const MTableFiltersRef = useRef({})
  const [historyModalReport, setHistoryModalReport] = useState(null);
  const [isAllMonths, setIsAllMonths] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false)
  const [allTablesOpen, setAllTablesOpen] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [show, setShow] = useState(false);
  const [showIndexDescription, setShowIndexDescription] = useState(null);

  // #region Perms
  const userCtx = useUserContext();
  const history = useHistory();
  // представители ответственных + ПО + АГ
  const canExport = () => userCtx.perms.includes('kpiAdmin') || isAdminRead(userCtx);
  // #endregion

  useEffect(async () => {
    const result = await getAllResults();
    setOriginalData(result);
    setIsLoaded(true)
  }, []);

  useMemo(() => {
    setData(originalData.filter(val => passByYear(val, filterYears)));
  }, [originalData, filterYears]);

  const handleChange = (e) => {
    const yearValue = parseInt(e.target.value);
    const newFilterYears = filterYears.includes(yearValue)
      ? filterYears.filter((item) => item !== yearValue).sort()
      : [...filterYears, yearValue].sort();
    setFilterYears(newFilterYears);
  };

  const handleHideAllButton = () => {
    setData(data?.map((d) => ({ ...d, tableData: { isTreeExpanded: !allTablesOpen } })));
    setAllTablesOpen(!allTablesOpen);
  }

  const getColumns = () => {
    const colsLeft = [
      {
        title: '№',
        field: 'num',
        editable: 'never',
        filterCellStyle: { width: '40px' },
        width:'80px'
      },
      {
        title: 'Показатель',
        field: 'name',
        editable: 'never',
        render: rowData => <div>
          {rowData.name}
          <HelpOutlineIcon
            style={{ opacity: 0.66, fontSize: 16, marginLeft: 4, marginBottom: 2, cursor: 'pointer'}}
            onClick={() => setShowIndexDescription(rowData)}
          />
          <CalcDescriptionModal show={showIndexDescription?.id === rowData.id} onHide={() => setShowIndexDescription(null)} index={showIndexDescription}/>
        </div>,
        filterCellStyle: { minWidth: '270px' },
        width:'270px',
        filterComponent: ({ columnDef, onFilterChanged })=><FilterInput columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={MTableFiltersRef} field="name" />

      },
      {
        title: 'Единица',
        field: 'unit',
        render: (rowData) => (rowData.unit === 'рублей' ? 'тыс. руб.' : rowData.unit),
        editable: 'never',
        width:'100px',
        filterCellStyle: { minWidth: '100px' },
        filterComponent: ({ columnDef, onFilterChanged })=><FilterInput columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={MTableFiltersRef} field="unit" />
      },
    ];

    const colsRight = [
      // {
      //   title: 'Ответственный 2021',
      //   field: `reportBosses2021`,
      //   editable: 'never',
      //   render: (rowData) => renderNamesString(rowData.reportBosses2021),
      // },
      // {
      //   title: 'Ответственный 2022',
      //   field: `reportBosses2022`,
      //   editable: 'never',
      //   render: (rowData) => renderNamesString(rowData.reportBosses2022),
      // },
    ];

    const byYearsColsFactory = (year) => {
      const result = [];
      if (year === 2022) {
        result.push({
          title: `Факт на конец полугодия ${year}`,
          field: `factHalf_${year}`,
          render: (rowData) => getFieldRenderFunction(rowData)(rowData[`factHalf_${year}`]),
          filterCellStyle: { minWidth: '135px' },
        });
      }
      if (year >= 2023) {
        months.filter((e)=> ['03', '04', '05', '06', '07'].includes(e) || isAllMonths).forEach((m) => {
          result.push({
            title: `Факт на 01.${m}.${year}`,
            field: `fact${m}_${year}`,
            render: (rowData) => getFieldRenderFunction(rowData)(rowData[`fact${m}_${year}`]),
            filterCellStyle: { minWidth: '135px' },
          });
        });
      }
      if (year >= 2022) {
        result.push({
          title: `Факт предварительного отчета ${year}`,
          field: `factSemi_${year}`,
          render: (rowData) => getFieldRenderFunction(rowData)(rowData[`factSemi_${year}`]),
          filterCellStyle: { minWidth: '135px' },
        });
      }
      return result;
    };

    const colsMiddle = filterYears.reduce(
      (acc, year) => [
        ...acc,
        {
          title: `План по Программе ${year}`,
          field: `plan${year}`,
          editComponent: renderEditMoneyComponent,
          render: (rowData) => getFieldRenderFunction(rowData)(rowData[`plan${year}`]),
          filterCellStyle: { minWidth: '135px' },
        },
        {
          title: `План максимум ${year}`,
          field: `planInner${year}`,
          editComponent: renderEditMoneyComponent,
          render: (rowData) => getFieldRenderFunction(rowData)(rowData[`planInner${year}`]),
          filterCellStyle: { minWidth: '135px' },
        },
        ...byYearsColsFactory(year),
        {
          title: `Прогноз ${year}`,
          field: `estimate${year}`,
          render: (rowData) => getFieldRenderFunction(rowData)(rowData[`estimate${year}`]),
          filterCellStyle: { minWidth: '135px' },
        },
        {
          title: `Факт ${year}`,
          field: `fact${year}`,
          render: (rowData) => getFieldRenderFunction(rowData)(rowData[`fact${year}`]),
          filterCellStyle: { minWidth: '135px' },
        },
        {
          title: `% выполнения ${year}`,
          field: `complete${year}`,
          render: (rowData) => !rowData.parentId && renderCompleteValue(rowData[`complete${year}`]),
          filterCellStyle: { minWidth: '135px' },
        },
        {
          title: `Комментарий ${year}`,
          field: `comment${year}`,
          filterCellStyle: { minWidth: '150px' },
        },
        {
          title: `Ответственный ${year}`,
          field: `reportBosses${year}`,
          editable: 'never',
          render: (rowData) => renderNamesString(rowData[`reportBosses${year}`]),
          filterComponent: ({ columnDef, onFilterChanged })=><FilterInput columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={MTableFiltersRef} field={`reportBosses${year}`} />
        },
      ],
      [],
    );

    return [...getStickyColumns(colsLeft,144), ...colsMiddle, ...colsRight];
  };

  const handleHideColumns = (columnName) => {
    const updatedHiddenColumns = hiddenColumns.includes(columnName) ? hiddenColumns.filter(value => value !== columnName) : ([...hiddenColumns, columnName])
    localStorage.setItem('hidden-fact-result-cols', JSON.stringify(updatedHiddenColumns))
    setHiddenColumns(updatedHiddenColumns)
  }

  useEffect(() => {
    const defaultHiddenColumns = JSON.parse(localStorage.getItem('hidden-fact-result-cols') || '[]')
    defaultHiddenColumns.push('Факт на 01.03.2024')
    setHiddenColumns(defaultHiddenColumns)
  }, []);

  return (
    <section className="">
      <div style={styledTable}>
        <MaterialTable
          options={modifyDefaultOptions({
            columnsButton: true,
            maxBodyHeight: 'calc(100vh - 442px)',
            rowStyle: (rowData) => ({
              backgroundColor: !rowData.parentId ? '#f5f5ff' : '#FFF',
            }),
            paging: false,
            headerStyle: { height: 50, position: 'sticky' },
            filterCellStyle: {
              position: 'sticky',
              top: 64,
              background: 'white',
            },
          })}
          icons={tableIcons}
          localization={localization}
          columns={getColumns().map(column => ({...column, hidden: hiddenColumns.includes(column.title)}))}
          data={data.filter((val, i, array) => !val.parentId || recursiveHasParent(val, array))}
          components={{
            Body:(props) => {
              return <LoadingTable spinnerStyle={{marginTop: '40px'}} loadingObject={{isLoaded}}><CustomTableActions WrapperComponent={MTableBody}  actionProps={props} haveChild={true} actionWidth={'72px'}/></LoadingTable>
            },
            Header:(props)=>{
              return <>{isLoaded && <CustomTableActions WrapperComponent={MTableHeader} actionProps={props} haveChild={true} actionWidth={'72px'}/>}</>
            },
            Actions:(props)=>{
              return <CustomTableActions WrapperComponent={MTableActions}  actionProps={props} haveChild={true} actionWidth={'72px'}/>
            },
            FilterRow: (props) => (<MTableFilterRow {...props} />),
            Toolbar: (props) => (
              <div>
                <div style={styledToolbarContainer}>
                  <h6 style={{fontSize: "20px", width: "100%"}}>Просмотр факта выполнения</h6>
                  <div style={{ width: '100%', marginRight: 20, textAlign: 'right' }}>
                    <button style={{display: 'inline-flex', border: 'none', backgroundColor: 'transparent', color: '#0D6EFD', fontSize: 16,  fontWeight: 700, fontFamily: 'Open-sans, sans-serif', padding: 0, columnGap: 10}} onClick={handleHideAllButton}>
                      {allTablesOpen ? 'Свернуть ' : 'Развернуть '}
                      все
                      <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg" transform={allTablesOpen ? "rotate(180), translate(0, -8)" : "rotate(0), translate(0, 8)"}>
                        <path d="M1 1.5L8 7.5L15 1.5" stroke="#0D6EFD" strokeWidth="2"/>
                      </svg>
                    </button>
                  </div>
                  <div>
                    <HideColumnButton
                      columns={props.columns.filter(column => !['num', 'name', 'unit'].includes(column.field))}
                      setHiddenColumns={handleHideColumns}
                      show={show}
                      setShow={setShow}
                    />
                  </div>
                  <div style={{ flex: 'none', marginLeft: 16 }}>
                    <Button onClick={() => history.push('add/index')}>+ Добавить показатель</Button>
                  </div>
                  {canExport && (
                  <div style={{ flex: 'none', marginLeft: 16 }}>
                    <DownloadLink
                      variant="outline-primary"
                      url={`/reports/kpis/0/results/export?years=${JSON.stringify(filterYears)}`}
                      filename={`Отчет по показателям_${dateRenderer(new Date())}.xlsx`}
                    >
                      Выгрузить в Excel
                    </DownloadLink>
                  </div>
                  )}
                </div>
                <div className="filters-container">
                  <div className="year-checkboxes">
                    {years.map((year, i) => (
                      <label key={year}>
                        <input
                          type="checkbox"
                          value={year}
                          onChange={handleChange}
                          checked={filterYears.includes(year)}
                        />
                        <span className="tag">{year}</span>
                      </label>
                    ))}
                  </div>
                </div>
                <div className="year-checkboxes">
                {filterYears.filter((e)=>e>=2023).length>0 &&
                 <label>
                 <input
                   type="checkbox"
                   checked={isAllMonths}
                   onChange={(e) =>
                    setIsAllMonths(e.target.checked)
                   }
                  />
                  <span className="tag">Отобразить все</span>
                 </label>
              }
                </div>
              </div>
            ),
          }}
          actions={[
            (data) => ({
              custom: true,
              hidden: data.parentId || !isAdmin(userCtx),
              icon: () => <img src={settingsIcon}/>,
              tooltip: 'Редактировать показатель',
              onClick: (e, data) => {
                history.push(`/indexes/add/index/${data.id}`)
              }
            }),
            (data) => ({
              custom: true,
              hidden: !data.parentId,
              icon: () => <History style={{ color: '#0D6EFD' }} />,
              tooltip: 'История изменений',
              onClick: (e, data) => {
                setHistoryModalReport({ id: data.id, num: data.num, name: data.name });
              },
            }),
          ]}
          title=""
          parentChildData={(row, rows) =>
            rows.find((a) => a.path === row.parentId)
          }
        />
      </div>
      {historyModalReport && <KpiHistoryModal report={historyModalReport} onClose={() => setHistoryModalReport(null)} />}
    </section>
  );
}

const styledTable = {
  maxWidth: '100%',
  marginTop: 32,
};
const styledToolbarContainer = { display: 'flex', alignItems: 'center', justifyContent: 'space-between' };
